import React from 'react';

type ContributionTimerHourglassIconProps = {
  animated?: boolean;
  className?: string;
  size?: number;
};

const ContributionTimerHourglassIcon = ({
  animated = false,
  className = '',
  size = 24
}: ContributionTimerHourglassIconProps): React.ReactElement => {
  const svgClassName = [
    'contribution-timer-hourglass',
    animated && 'contribution-timer-hourglass--running',
    className
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <svg
      aria-hidden="true"
      className={svgClassName}
      fill="none"
      height={size}
      viewBox="0 0 24 24"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 3h12M6 21h12"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="1.8"
      />
      <path
        d="M7.25 4c0 3.55 1.72 5.75 4.75 8-3.03 2.25-4.75 4.45-4.75 8M16.75 4c0 3.55-1.72 5.75-4.75 8 3.03 2.25 4.75 4.45 4.75 8"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      {animated ? (
        <>
          <path
            className="contribution-timer-hourglass__sand--running-top"
            d="M7.8 5.1h8.4L12 10.2 7.8 5.1Z"
            fill="currentColor"
          />
          <path
            className="contribution-timer-hourglass__sand--running-bottom"
            d="M9.2 19.75h5.6L12 18.1l-2.8 1.65Z"
            fill="currentColor"
          />
          <circle
            className="contribution-timer-hourglass__grain contribution-timer-hourglass__grain--one"
            cx="12"
            cy="10.3"
            fill="currentColor"
            r="1"
          />
          <circle
            className="contribution-timer-hourglass__grain contribution-timer-hourglass__grain--two"
            cx="12"
            cy="10.3"
            fill="currentColor"
            r="1"
          />
          <circle
            className="contribution-timer-hourglass__grain contribution-timer-hourglass__grain--three"
            cx="12"
            cy="10.3"
            fill="currentColor"
            r="1"
          />
        </>
      ) : (
        <path
          className="contribution-timer-hourglass__sand--settled"
          d="M7.8 19.75h8.4L12 14.65l-4.2 5.1Z"
          fill="currentColor"
        />
      )}
    </svg>
  );
};

export default ContributionTimerHourglassIcon;
